import { createGlobalStyle } from 'styled-components';
import 'rc-slider/assets/index.css';
import '../fonts/Inter.css';
import 'tippy.js/dist/tippy.css';
export const GlobalStyle = createGlobalStyle`
  ${({ theme: { colors, typography } }) => `
    @font-face {
      font-family: Inter-Regular;
    }
    *,
    *::after,
    *::before {
      box-sizing: border-box;
    }
    body {
      font-family: Inter-Regular;
      margin: 0;
      padding: 0;
      font-size: ${typography.size.desktop.paragraph.p1};
      font-weight: ${typography.weight.normal};
      line-height: ${typography.lineHeight[2]};
    }
    ul, li {
      list-style: none;
    }
    ul, li, p, label, h1, h2, h3, h4, h5, h6 {
      margin: 0;
      padding: 0;
    }
    main a {
      text-decoration: none;
      color: ${colors.primary} !important;
      &:hover {
        background: ${colors.hover};
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .up {
      color: ${colors.alert.green} !important;
    }
    .down {
      color: ${colors.alert.red} !important;
    }
    .bg-up {
      background: ${colors.alert.green} !important;
    }
    .bg-down {
      background: ${colors.alert.red} !important;
    }
    .index {
      color: ${colors.alert.yellow} !important;
    }
    .tooltip {
      max-width: 250px;
      font-size: ${typography.size.desktop.paragraph.p3};
      color: ${colors.text.primary};
      background: ${colors.background.secondary.v3};
      .tippy-arrow {
        color: ${colors.background.secondary.v3};
      }
      &.tooltip-light {
      }
    }  
    .clickable {
      cursor: pointer;
    }
   .clickable-disabled {
      cursor: not-allowed;
    }
    :root {
      --toastify-color-light: ${colors.background.secondary.v3};
      --toastify-color-dark: ${colors.background.secondary.v3};
  
      --toastify-toast-background: ${colors.background.secondary.v3};
      --toastify-font-family: IBMPlexSans-Regular;
    
      --toastify-text-color-light: ${colors.text.primary};
      --toastify-text-color-dark: ${colors.text.primary};
    }
    .Toastify__toast {
      padding: 12px 16px;
      border-radius: 6px;
    }
    .Toastify__toast-container {
       z-index: 15000;
    }
    .Toastify__toast-body {
      padding: 0;
      flex: unset;
      margin: unset;
      width: 100%;
      flex-wrap: wrap;
      & > div:nth-of-type(1) {
        & > div {
          :nth-of-type(1) {
            > svg {
              min-width: fit-content;
            }
            font-size: ${typography.size.desktop.paragraph.p2};
            line-height: calc(${typography.lineHeight[3]} - 0.5px);
          }
          :nth-of-type(2) {
            line-height: calc(${typography.lineHeight[2]} - 1px);
            font-size: ${typography.size.desktop.paragraph.p3};
            color: ${colors.text.tertiary};
          }
        } 
      }
    }
    .tippy-box[data-theme~='secondary'] {
      background-color: ${colors.background.secondary.v4};
    }
    .tippy-box[data-theme~='secondary'][data-placement^='top'] > .tippy-arrow::before {
      border-top-color: ${colors.background.secondary.v4};
    }
    .tippy-box[data-theme~='secondary'][data-placement^='bottom'] > .tippy-arrow::before {
      border-bottom-color: ${colors.background.secondary.v4};
    }
    .tippy-box[data-theme~='secondary'][data-placement^='left'] > .tippy-arrow::before {
      border-left-color: ${colors.background.secondary.v4};
    }
    .tippy-box[data-theme~='secondary'][data-placement^='right'] > .tippy-arrow::before {
      border-right-color: ${colors.background.secondary.v4};
    }
    .__floater.__floater__open {
      & button {
        font-family: IBMPlexSans-Regular;
        &:focus-visible {
          outline: none;
        }
      }
    }
  `}

  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
